import React from 'react';

import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { RegisterAddedProvider } from './registerAdded';
import { GrupoPizzaProvider } from './grupoPizza';
import { ProdutoPizzaProvider } from './produtoPizza';
import { CloneProdutoProvider } from './cloneProduto';
import { HeaderProvider } from './header';
import { SimpleProductProvider } from './simpleProduct';
import { SimpleGroupProvider } from './simpleGroup';
import { PizzaGroupProvider } from './pizzaGroup';
import { ComplementsProvider } from './complements';
import { GridGroupProvider } from './gridGroup';
import { GridProductProvider } from './gridProduct';
import { PizzaProductProvider } from './pizzaProduct';
import { MonitorProvider } from './newMonitor';

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <ToastProvider>
      <RegisterAddedProvider>
        <GrupoPizzaProvider>
          <ProdutoPizzaProvider>
            <CloneProdutoProvider>
              <HeaderProvider>
                <SimpleProductProvider>
                  <PizzaProductProvider>
                    <GridProductProvider>
                      <SimpleGroupProvider>
                        <PizzaGroupProvider>
                          <GridGroupProvider>
                            <ComplementsProvider>
                              <MonitorProvider>
                                {children}
                              </MonitorProvider>
                            </ComplementsProvider>
                          </GridGroupProvider>
                        </PizzaGroupProvider>
                      </SimpleGroupProvider>
                    </GridProductProvider>
                  </PizzaProductProvider>
                </SimpleProductProvider>
              </HeaderProvider>
            </CloneProdutoProvider>
          </ProdutoPizzaProvider>
        </GrupoPizzaProvider>
      </RegisterAddedProvider>
    </ToastProvider>
  </AuthProvider>
);

export default AppProvider;
